import { useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import '../App.css';
import RecentPost from "../RecentPost";
import ContactNumber from "../ContactNumber";
import { Helmet } from "react-helmet";

export default function Pgforworkingprofessional(){
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };
    

      const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
      };
    
    
      const faqs = [
        {
          question: "What types of rooms are available for working professionals at Om Sai PG?",
          answer: "Om Sai PG offers well-furnished single, double, and triple-sharing rooms, equipped with all essential amenities like beds, wardrobes, study tables, and chairs to suit the needs of working professionals."
        },
        {
          question: "Are meals provided at Om Sai PG?",
          answer: "Yes, home-cooked meals are provided at Om Sai PG. We offer breakfast, lunch, and dinner, catering to various dietary preferences, including vegetarian and non-vegetarian options."
        },
        {
          question: "How much does the rent cost for working professionals?",
          answer: "The rent at Om Sai PG depends on the room type and sharing arrangement. The rent is affordable and inclusive of all amenities such as meals, Wi-Fi, housekeeping, and utilities."
        },
        {
          question: "Is there Wi-Fi available at Om Sai PG?",
          answer: "Yes, we provide high-speed Wi-Fi throughout the PG, so you can stay connected for work, online meetings, and personal use without any interruptions."
        },
        {
          question: "How secure is Om Sai PG for working professionals?",
          answer: "Security is a top priority at Om Sai PG. The premises are monitored by 24/7 security personnel and CCTV cameras, ensuring the safety of all residents."
        },
        {
          question: "Are laundry services available?",
          answer: "Yes, we offer laundry services to make your life easier. You don’t need to worry about washing your clothes during your stay at Om Sai PG."
        },
        {
          question: "Is parking available for residents?",
          answer: "Yes, Om Sai PG provides parking space for residents with vehicles, ensuring the safety and convenience of your vehicle."
        },
        {
          question: "Is Om Sai PG located near corporate offices or IT hubs?",
          answer: "Yes, Om Sai PG is strategically located in a well-connected area of Pune, with easy access to corporate offices, IT hubs, and commercial centers. This makes commuting convenient for working professionals."
        },
        {
          question: "Can I bring guests or visitors to Om Sai PG?",
          answer: "Visitors are generally allowed, but prior permission from the management is required. We ensure the safety and privacy of all residents, so we ask for cooperation in maintaining the peaceful environment of the PG."
        },
        {
          question: "Can I book a room for a short duration?",
          answer: "Om Sai PG primarily caters to long-term stays, but short-term stays can be arranged depending on room availability. Please contact us for further information and availability."
        }
      ];
      
      const testimonials = [
        {
          quote: "I’ve been staying at this PG in Pune for the past few months, and it has been a fantastic experience. As a working professional, the peace and quiet of the place make it an ideal choice for me. The rooms are spacious, well-maintained, and have all the necessary amenities, including a desk for work. The food is nutritious and served on time, which fits perfectly into my busy schedule. The PG is well-connected to public transport, making my commute to work easy. I highly recommend it to anyone looking for a comfortable and hassle-free stay!",
          author: "- Vikram Kulkarni"
        },
        {
          quote: "This PG for working professionals in Pune has been a game changer for me. The accommodation is comfortable, with everything you need for a peaceful living experience. The rooms are clean and have a great work atmosphere, which is essential for me after a long day at the office. The food is delicious and caters to the needs of working professionals. The PG is located in a prime area with good connectivity to the city’s business hubs. The staff is courteous and always ready to help. I feel completely at home here!",
          author: "- Meera Joshi"
        }
      ];
      
      
      
    
    return(
        <>

<Helmet>
  {/* JSON-LD Structured Data */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Om Sai PG",
      "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
      "url": "https://www.omsaipg.in/PG-for-Working-Professionals-Pune",
      "logo": "https://www.omsaipg.in/images/logo.jpg",
      "image": "https://www.omsaipg.in/images/img/keyword-image/pg-for-working-professionals.jpg",
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+91 9763888448",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
        {
          "@type": "ContactPoint",
          "telephone": "+91 9922248255",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "bestRating": "5",
        "worstRating": "1",
        "ratingValue": "4.7",
        "ratingCount": "250",
      },
      "email": "omsaipg@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
        "addressLocality": "Kharadi",
        "addressRegion": "Maharashtra",
        "postalCode": "411014",
        "addressCountry": "IN",
      },
      "sameAs": [
        "https://www.facebook.com/omsaipg",
        "https://www.instagram.com/omsaipg",
        "https://www.linkedin.com/company/omsaipg"
      ],
      "priceRange": "INR 8,500-6000",
      "paymentAccepted": "Cash, UPI, Credit Card",
      "telephone": "+91 9763888448",
      "email": "omsaipgpune@gmail.com",
      "keywords": [
        "PG in Pune",
        "PG in Kharadi",
        "PG with food in Pune",
        "PG for Working Professionals in Kharadi",
        "Luxury PG in Kharadi",
        "Paying Guest Near Kharadi IT Park",
        "PG in Kharadi with food",
        "Hostels in Pune",
        "PG for professionals in Pune"
      ],
      "openingHours": "Mo-Su 09:00-22:00"
    })}
  </script>

  {/* Title */}
  <title>
    Om Sai PG | Best PG for Working Professionals in Kharadi Pune | Luxury PG with Food & Amenities
  </title>

  {/* Meta Tags */}
  <meta
    name="description"
    content="Om Sai PG offers affordable and comfortable PG accommodations in Kharadi, Pune, with food and essential amenities for working professionals and residents."
  />
  <meta
    name="keywords"
    content="PG for Working Professionals Pune, Luxury PG in Kharadi, Paying Guest Near Kharadi IT Park, PG in Kharadi with food, Hostels in Pune"
  />
  <meta name="robots" content="index, follow" />

  {/* Open Graph Tags */}
  <meta
    property="og:title"
    content="Om Sai PG - Best PG for Working Professionals in Kharadi Pune | PG with Food"
  />
  <meta
    property="og:description"
    content="Looking for PG accommodations in Kharadi Pune? Om Sai PG offers comfortable, affordable, and luxurious PG for working professionals with food and amenities."
  />
  <meta property="og:image" content="https://www.omsaipg.in/img/keyword-image/pg-for-working-professionals.jpg" />
  <meta property="og:url" content="https://www.omsaipg.in/PG-for-Working-Professionals-Pune" />
  <meta property="og:type" content="website" />
</Helmet>


     <section class="section-breadcrumb padding-b-50">
        <div class="rx-breadcrumb-image bg-img">
            <div class="rx-breadcrumb-overlay"></div>
            <div class="inner-breadcrumb-contact">
                <div class="main-breadcrumb-contact">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="rx-banner-contact">
                                    <h2>PG for Working Professionals Pune</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rx-banner-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="breadcrumb-contact">
                                    <div class="main-heading">
                                        <h4>PG for Working Professionals Pune</h4>
                                    </div>
                                    <div class="last-contact">
                                        <ul>
                                            <li>
                                                <Link to="/">Home</Link>
                                            </li>
                                            <li>PG for Working Professionals Pune</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

      {/* <!-- Page Banner End --> */}

      <div class="section-about padding-tb-50 keywordsection">
        <div className="container">
          <div className="row d-flex justify-content-around">
            <div className="col-12 col-md-8">
              <div className="keyword-img">
                <img src="img/keyword-image/pg-for-working-professionals.jpg" className="img-fluid" alt="pg-for-working-professionals" />
              </div>

              <h1>PG for Working Professionals in Pune – Om Sai PG: Comfort and Convenience at Your Doorstep</h1>

<p>Finding a PG for working professionals in Pune can be a challenge, but Om Sai PG offers the ideal solution. With its strategic location in Kharadi, close to major IT parks, business hubs, and transport links, Om Sai PG provides a comfortable, convenient, and affordable living experience for working professionals.</p>

<p>Whether you are new to Pune or just looking for a more convenient living arrangement, Om Sai PG offers the perfect blend of privacy, amenities, and affordability. Read on to learn why Om Sai PG is the best choice for working professionals.</p>

<h2>Why Om Sai PG is the Best Choice for Working Professionals in Pune?</h2>

<p>Pune is a bustling city filled with numerous career opportunities, especially in the IT and business sectors. Kharadi is one of the prime areas where Eon IT Park and other IT hubs are located, making it the perfect place to stay. Om Sai PG ensures that working professionals enjoy the best of both worlds: a peaceful and homely environment with all the amenities you need for a comfortable and productive stay.</p>

<h2>Facilities at Om Sai PG for Working Professionals</h2>

<p>Om Sai PG understands the needs of working professionals and provides modern amenities that make daily life easier. Here’s what you can expect:</p>

<h3>1. Fully Furnished Rooms</h3>
<p>Our fully furnished rooms come with all the essentials, including comfortable beds, wardrobes, study tables, and chairs. Each room is designed to offer a relaxing and productive environment to unwind after a long day at work.</p>

<h3>2. High-Speed Wi-Fi</h3>
<p>Stay connected to your work, colleagues, and clients with high-speed Wi-Fi. Whether you need to attend virtual meetings, work from home, or stream content for relaxation, our internet connection is fast and reliable.</p>

<h3>3. Breakfast and Dinner Included</h3>
<p>No need to worry about cooking after a long workday. Om Sai PG provides home-cooked meals that include breakfast and dinner every day. The meals are nutritious and offer the perfect balance of taste and health.</p>

<h3>4. 24/7 Water Supply and Hot Water</h3>
<p>Enjoy uninterrupted access to clean water with our 24/7 water supply. Additionally, we provide hot water around the clock, so you can enjoy a relaxing shower at any time of the day.</p>

<h3>5. Free Housekeeping Services</h3>
<p>To ensure your room and common areas are always clean and tidy, we provide free housekeeping services. This saves you time and ensures that you can focus on your work and relax in a clean, well-maintained environment.</p>

<h3>6. CCTV Surveillance for Safety</h3>
<p>Your safety is a priority. Om Sai PG is equipped with CCTV cameras, ensuring 24/7 surveillance and providing a secure and peaceful environment for all residents.</p>

<h3>7. Electricity Bills Included</h3>
<p>At Om Sai PG, there are no hidden charges. Electricity bills are included in the rent, so you won’t have to worry about managing your monthly bills.</p>

<h3>8. Fridge and Gas Facility</h3>
<p>For those who prefer to store food or cook their own meals, we offer a fridge and gas facility. This flexibility is perfect for working professionals who want to save time or prepare their own meals.</p>

<h3>9. 2-Wheeler Parking</h3>
<p>If you commute by bike or scooter, Om Sai PG offers secure 2-wheeler parking. Your vehicle will be safe and accessible whenever you need it.</p>

<h3>10. Purified Drinking Water</h3>
<p>To ensure your health, we provide purified drinking water at all times, so you can stay hydrated without any worries.</p>


<h2>Affordable Rent Options for Working Professionals at Om Sai PG</h2>

<p>Om Sai PG offers a range of rent packages that cater to the needs of working professionals. The rent is affordable, and it includes all essential amenities. Here are the available options:</p>
<ul>
    <li><strong>Single Sharing Room:</strong> ₹8,500 per month (including breakfast and dinner)</li>
    <li><strong>Double Sharing Room:</strong> ₹7,000 per month (including breakfast and dinner)</li>
    <li><strong>Triple Sharing Room:</strong> ₹6,000 per month (including breakfast and dinner)</li>
</ul>
<p>A deposit of ₹3,000 is required at the time of booking, along with one month’s advance rent.</p>

<h2>Prime Location in Kharadi – Ideal for Working Professionals</h2>

<p>Om Sai PG is located in Kharadi, one of Pune’s most sought-after areas for professionals, especially those working in the IT sector. The PG is close to key business hubs like Eon IT Park, making it an excellent choice for employees working in nearby offices. Additionally, the area is well-connected by public transport, making it easy to commute to other parts of the city.</p>

<h2>How to Book a Room at Om Sai PG for Working Professionals?</h2>

<p>Booking your stay at Om Sai PG is simple and quick. You can contact us at the following phone numbers:</p>
<ul>
    <li><strong>Phone:</strong> 9763888448 | 9922248255</li>
</ul>
<p>Alternatively, you can visit our PG for a personal tour of the premises and choose the room that best suits your needs.</p>

<h2>Contact Information for Om Sai PG</h2>

<ul>
    <li><strong>Phone:</strong> 9763888448 | 9922248255</li>
</ul>

<h2>PG for IT Professionals Kharadi Pune</h2>

<p>Kharadi is home to many IT parks, making it the ideal location for IT professionals seeking accommodation. These PGs offer spacious rooms, high-speed internet, 24/7 security, and home-cooked meals. With easy access to EON IT Park, Kharadi provides a perfect living solution for those working in the tech industry. Whether you need a shared or private room, these PGs ensure comfort and convenience.</p>

<h2>PG for Software Engineers Kharadi Pune</h2>

<p>For software engineers in Kharadi Pune, finding a comfortable and well-equipped PG is easy. The area is surrounded by several tech hubs, including EON IT Park, making it an ideal choice for software engineers. PGs here provide excellent facilities such as high-speed internet, study tables, nutritious meals, and ample security. These accommodations cater to the professional needs of software engineers looking for a home away from home.</p>

<h2>PG for MBA Students in Pune</h2>

<p>Looking for a PG for MBA students in Pune? Pune is home to several prestigious institutions, and if you’re an MBA student, you'll find plenty of PGs offering quiet, conducive environments to study and focus. PGs for MBA students are available across areas like Kharadi, Hinjewadi, and Koregaon Park, offering services such as Wi-Fi, food, laundry, and 24/7 security. They are located near top MBA colleges like Symbiosis, making it convenient for students to commute.</p>

<h2>PG for Law Students in Pune</h2>

<p>If you’re a law student in Pune, you’ll find a variety of PG options suited to your needs. Located near law schools like the ILS Law College and Pune University, PGs for law students offer quiet study spaces, nutritious meals, and secure living conditions. These PGs often provide essential services such as high-speed internet and 24/7 security to ensure that law students have everything they need for a focused academic life.</p>

<h2>PG for Couples in Kharadi IT Park</h2>

<p>If you're looking for a PG for couples in Kharadi IT Park, you’ll find several PG accommodations that offer privacy and comfort. These PGs are designed to meet the needs of couples working or studying in Kharadi. With amenities such as home-cooked meals, Wi-Fi, and round-the-clock security, PGs for couples in Kharadi offer a homely and peaceful environment. The proximity to EON IT Park and other commercial hubs adds to the convenience of staying in Kharadi.</p>

<h2>PG Near Kharadi IT Park Pune</h2>

<p>Kharadi is a prime location for working professionals, especially those employed in IT. PGs in this area provide well-equipped rooms, nutritious meals, and other essential services, making them an ideal choice for professionals working at EON IT Park or nearby tech hubs. With easy access to offices and transportation, these PGs offer convenience and comfort for busy professionals.</p>

<h2>PG for Working Professionals Pune</h2>

<p>Pune is a hub for working professionals, and finding a PG for working professionals in Pune is easy. Whether you're a male or female, PGs for working professionals provide secure accommodations with essential amenities like Wi-Fi, meals, laundry, and security. Locations like Kharadi, Hinjewadi, and Koregaon Park offer easy access to tech parks and business districts, ensuring a comfortable stay while working in Pune.</p>

<h2>PG for Working Male & Female in Pune</h2>

<p>Pune offers diverse PG options that cater to both male and female professionals. These PGs are equipped with all the necessary amenities such as high-speed internet, food services, laundry, and security. With affordable rent and proximity to business hubs like Kharadi IT Park, PGs for working male and female in Pune offer convenience and comfort for professionals.</p>

<h2>PG for Medical Students Kharadi</h2>

<p>If you’re a medical student in Kharadi, you’ll find PGs that provide a peaceful environment with all the essential services needed for your studies. These PGs offer spacious rooms, high-speed internet, nutritious meals, and 24/7 security, making them perfect for medical students who need a safe and quiet place to stay. Located near medical colleges and hospitals, PGs for medical students in Kharadi offer easy access to educational institutions and healthcare facilities.</p>

<h2>PG for BPO Employees in Kharadi</h2>

<p>For BPO employees in Kharadi, finding a comfortable PG near your workplace is easy. PGs in Kharadi are designed to cater to the needs of working professionals, including those in the BPO sector. These PGs offer amenities such as home-cooked meals, high-speed internet, laundry services, and 24/7 security. With easy access to BPO companies and tech parks in Kharadi, these accommodations provide a great living solution for professionals working late shifts or long hours.</p>

<h2>PG for Working Professionals Near Me</h2>

<p>If you're searching for a PG for working professionals near me, Pune has numerous PG options that cater to professionals across various industries. These PGs offer a range of amenities including comfortable rooms, meals, high-speed internet, and security. Located in key areas like Kharadi, Hinjewadi, and Koregaon Park, PGs for working professionals offer convenience and comfort with easy access to workplaces, tech parks, and transport networks.</p>

<h2>PG for Working Professionals in Kharadi Pune</h2>

<p>Kharadi is home to a variety of PGs designed specifically for working professionals. With modern amenities such as air-conditioned rooms, Wi-Fi, nutritious food, and 24/7 security, these PGs ensure a comfortable living experience. Located near major IT parks and business hubs, PGs for working professionals in Kharadi provide easy access to offices, tech parks, and transport services, making them the perfect choice for busy professionals.</p>

<h2>PG in Kharadi Near EON IT Park</h2>

<p>Kharadi offers many PG accommodations that are just a stone's throw away from EON IT Park. These PGs offer spacious rooms, Wi-Fi, nutritious meals, and a secure environment, making them the perfect choice for IT professionals and tech industry workers. With easy access to offices in the IT park, transportation, and other conveniences, PGs near EON IT Park Kharadi offer both comfort and practicality.</p>

<h2>Luxury PG Near EON IT Park Kharadi</h2>

<p>If you're looking for a luxury PG near EON IT Park Kharadi, several high-end options provide premium services and comfort. These luxury PGs offer spacious rooms, modern furniture, air conditioning, 24/7 security, gym access, and high-speed internet. Located near EON IT Park and other business hubs, luxury PGs in Kharadi are designed for professionals who want a more comfortable and stylish living environment while being close to work.</p>

<h2>Single Room PG in Kharadi, Pune for Male</h2>

<p>Kharadi offers a wide range of private single-room PGs for male professionals. These PGs provide amenities such as home-cooked meals, Wi-Fi, laundry, and security. With a peaceful and private atmosphere, single room PGs in Kharadi are perfect for those who need personal space while staying near major tech hubs and commercial areas.</p>

<h2>Best PG in Kharadi Pune</h2>

<p>Kharadi is home to several well-maintained and well-equipped PGs that cater to the needs of working professionals and students alike. These PGs offer essential amenities like food services, Wi-Fi, laundry, and security. With easy access to IT parks, educational institutions, and shopping centers, the best PGs in Kharadi ensure a comfortable and convenient living experience for all.</p>



              <table
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                  borderWidth: "0px",
                }}
                border="1"
              >
                <colgroup>
                  <col style={{ width: "49.9491%" }} />
                  <col style={{ width: "49.9491%" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td style={{ borderWidth: "0px" }}>
                    <p> - PG for IT Professionals Kharadi Pune</p>
<p> - PG for Software Engineers Kharadi Pune</p>
<p> - PG for MBA Students in Pune</p>
<p> - PG for Law Students in Pune</p>
<p> - PG for Couples in Kharadi IT Park</p>
<p> - PG Near Kharadi IT Park Pune</p>
<p> - PG for Working Professionals Pune</p>
<p> - PG for Working Male & Female in Pune</p>
                    </td>
                    <td style={{ borderWidth: "0px" }}>
                  
<p> - PG for Medical Students Kharadi</p>
<p> - PG for BPO Employees in Kharadi</p>
<p> - PG for Working Professionals Near Me</p>
<p> - PG for Working Professionals in Kharadi Pune</p>
<p> - PG in Kharadi Near Eon IT Park</p>
<p> - Luxury PG Near Eon IT Park Kharadi</p>
<p> - Single Room PG in Kharadi, Pune for Male</p>
<p> - Best PG in Kharadi Pune</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h2>Why Choose Om Sai PG for Working Professionals in Pune?</h2>

<h3>1. Prime Location in Pune</h3>
<p>Om Sai PG is located in a prime area of Pune, offering easy access to the city’s bustling IT hubs, corporate offices, and key commercial centers. Our PG is well-connected by public transport, making it an ideal choice for working professionals who need to commute easily to work.</p>

<h3>2. Fully Furnished and Comfortable Rooms</h3>
<p>Our PG offers spacious and fully furnished rooms with essential amenities like comfortable beds, wardrobes, study tables, chairs, and air-conditioning (in select rooms). We focus on creating a relaxing, cozy, and functional space for working professionals after a long workday.</p>

<h3>3. Affordable Rent with All-Inclusive Services</h3>
<p>Om Sai PG offers competitive rent packages with all-inclusive services, such as meals, electricity, water, Wi-Fi, and housekeeping. This makes it easier for professionals to manage their expenses without any hidden costs.</p>

<h3>4. Nutritious Home-Cooked Meals</h3>
<p>We understand the importance of healthy, home-cooked food for working professionals. Our meals are freshly prepared daily, offering a variety of options for breakfast, lunch, and dinner. The menu caters to different dietary needs and preferences, ensuring you stay energized throughout the day.</p>

<h3>5. High-Speed Internet Connectivity</h3>
<p>At Om Sai PG, we provide high-speed Wi-Fi access across the premises, allowing professionals to stay connected for work, video calls, or leisure. Our internet connectivity is reliable, making it easier for you to complete work-related tasks or manage your personal commitments online.</p>

<h3>6. 24/7 Security and CCTV Surveillance</h3>
<p>Security is a top priority at Om Sai PG. We have 24/7 security personnel and CCTV cameras installed throughout the premises to ensure the safety of all our residents. Working professionals can feel secure and relaxed in their living space.</p>

<h3>7. Cleanliness and Hygiene</h3>
<p>Our team maintains high standards of cleanliness and hygiene in all rooms, bathrooms, dining areas, and common spaces. Regular cleaning and housekeeping services are provided to create a fresh and pleasant living environment.</p>

<h3>8. Laundry Services</h3>
<p>We provide convenient laundry services for working professionals to ensure that you don’t have to worry about washing clothes. This service is designed to make your life easier, allowing you to focus on work and other important tasks.</p>

<h3>9. Spacious Common Areas for Relaxation</h3>
<p>Om Sai PG offers ample common areas for relaxation, socializing, and unwinding. Whether you need to interact with fellow professionals or simply relax after a busy day, our common spaces provide a perfect setting for both.</p>

<h3>10. Supportive and Friendly Management</h3>
<p>Our management team is friendly, approachable, and always available to assist you with any queries or requirements. We aim to ensure that your stay is as comfortable and hassle-free as possible, so you can focus on your work without distractions.</p>



              <div className="">
                  <h2>
                  FAQs for Om Sai PG for Working Professionals in Pune ? 
                  </h2>
                  {faqs.map((faq, index) => (
                    <div key={index} className="faq-item">
                      <div
                        className={`faq-question ${
                          activeIndex === index ? "active" : ""
                        }`}
                        onClick={() => toggleAccordion(index)}
                      >
                        {index + 1}. {faq.question}
                      </div>
                      {activeIndex === index && (
                        <div className="faq-answer">{faq.answer}</div>
                      )}
                    </div>
                  ))}
                </div>


                  {/* ======================== */}
                  <div className="container">
                    <div className="testimonial-section">
                  <h2>
                  Testimonial for a PG for working professionals in Pune :-  {" "}
                  </h2>
                  <Slider {...settings}>
                    {testimonials.map((testimonial, index) => (
                      <div key={index} className="testimonial-slide">
                        <blockquote>
                          <p>{testimonial.quote}</p>
                          <footer>— {testimonial.author}</footer>
                        </blockquote>
                      </div>
                    ))}
                  </Slider>
                  </div>
                </div>

                {/* ================= */}
                <ContactNumber></ContactNumber>
            </div>
           <RecentPost></RecentPost>
        
        </div>
        </div>
      </div>
    </>
  );
}
